import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import {
  CreateAnnouncementDto,
  PublicAnnouncement,
} from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const createAnnouncement = async (
  announcement: CreateAnnouncementDto,
): Promise<PublicAnnouncement> => {
  const response = await axiosClient.post("/announcements", announcement);
  return response.data;
};

function useCreateAnnouncement(
  mutationOptions?: UseMutationOptions<
    PublicAnnouncement,
    HttpError,
    CreateAnnouncementDto
  >,
) {
  return useMutation({
    mutationFn: createAnnouncement,
    ...mutationOptions,
  });
}

export { useCreateAnnouncement };
